
import { onBeforeUnmount, ref, watch } from "vue";
import _ from "lodash";
import { useIntervalFn } from "@vueuse/core";
export default {
  props: {
    duration: Number,
    color: {
      type: String,
      required: false,
      default: "#51a7ff"
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "rgba(0, 0, 0, 0.2)"
    },
    height: {
      type: Number,
      required: false,
      default: 3
    },
    isPaused: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["end", "progress"],
  setup(props: {}, context: { emit: Function }) {
    const progress = ref((props as { duration: number }).duration),
      interval = 20;

    const { pause } = useIntervalFn(
      () => {
        progress.value = _.max([progress.value - interval, 0])!;
        context.emit("progress", progress.value);
        if (progress.value === 0) {
          pause();
          context.emit("end");
        }
      },
      interval,
      {
        immediateCallback: true
      }
    );

    watch(
      () => (props as { isPaused: boolean }).isPaused,
      (newVal, oldVal) => {
        if (newVal && !oldVal) {
          pause();
        }
      }
    );

    onBeforeUnmount(() => pause());

    return {
      progress,
      ...props
    };
  }
};
